module.exports = __webpack_public_path__ + "static/media/icon.heart.alone.blue.60c9bb02.svg";